module.exports = __webpack_public_path__ + "static/fort-d26eec991f094163197423b1534eabe7.png";